import { useState, useEffect } from "react";

import {
  CCard,
  CCardBody,
  CCardText,
  CCol,
  CRow,
  CCardTitle,
  CSpinner
} from "@coreui/react";
import { GiCardExchange } from "react-icons/gi";
import { MdPublishedWithChanges } from "react-icons/md";
import { SiGoogleclassroom } from "react-icons/si";

import "./LogCards.css";

const LogCards = props => {
  let [updates, setUpdates] = useState(
    <CSpinner size="sm" color="secondary" className="mr-2" />
  );
  let [statusChange, setStatusChange] = useState(
    <CSpinner size="sm" color="secondary" className="mr-2" />
  );
  let [losProduction, setLosProduction] = useState(
    <CSpinner size="sm" color="secondary" className="mr-2" />
  );
  useEffect(() => {
    if (!props.loading) {
      setUpdates(props.Total);
      setStatusChange(props.newStatus);
      setLosProduction(props.newAulas);
    }
  }, [props]);

  return (
    <CRow className="minus-mb-6">
      <CCol className="minus-mb-6">
        <CCard
          color="success"
          textColor="white"
          style={{
            background: "linear-gradient(45deg, black, #009688)"
          }}
        >
          <CCardBody>
            <SiGoogleclassroom size={40} style={{ opacity: "0.5" }} />

            <CCardTitle>Novas aulas:</CCardTitle>
            <CCardText style={{ fontSize: "2em" }}>{losProduction}</CCardText>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol className="minus-mb-3">
        <CCard
          color="primary"
          textColor="white"
          style={{
            border: "none",
            background: "linear-gradient(45deg, black, #007bff)"
          }}
        >
          <CCardBody>
            <GiCardExchange size={40} style={{ opacity: "0.5" }} />
            <CCardTitle>Mudanças de Status:</CCardTitle>
            <CCardText style={{ fontSize: "2em" }}>{statusChange}</CCardText>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol className="minus-mb-3">
        <CCard
          color="warning"
          textColor="white"
          style={{
            border: "none",
            background: "linear-gradient(45deg, black, #ffc107)"
          }}
        >
          <CCardBody>
            <MdPublishedWithChanges size={40} style={{ opacity: "0.5" }} />
            <CCardTitle>Total atualizações:</CCardTitle>
            <CCardText style={{ fontSize: "2em" }}>{updates}</CCardText>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default LogCards;
